<script setup lang="ts">

import { onMounted, onUnmounted, ref } from 'vue';

import NavigationArrow from './Components/NavigationArrow.vue';
import Panel1 from './Panels/Panel1.vue';
import Panel2 from './Panels/Panel2.vue';
import Panel3 from './Panels/Panel3.vue';

const currentPanel = ref( 0 );
const panels = [ Panel1, Panel2, Panel3 ];
const category = ref( 1 );

// Hide podium when the presentation is running
onMounted( () => document.querySelector( 'body' )!.classList.add( 'hide-podium' ) );
onUnmounted( () => document.querySelector( 'body' )!.classList.remove( 'hide-podium' ) );

function onCategorySelected( value: number )
{
    category.value = value;
    currentPanel.value = 1;
}

</script>

<template>

    <div class="h-full overflow-hidden">

        <div class="
            h-full overflow-y-auto
            text-white tracking-wider
            ">
            
            <div class="
                min-h-full
                bg-gradient-to-b from-[#1d1f48] to-[#363483]">
            
                <img src="/images/explanations/presidian-group-logo.png" 
                    class="h-12 3xl:h-20 absolute right-8 top-8"
                />

                <img src="/images/explanations/protect/protect-logo.png"
                    class="h-7 3xl:h-10 absolute left-8 top-8"     
                />

                <v-carousel
                    v-model="currentPanel"
                    direction="vertical"
                    :show-arrows="false"
                    vertical-delimiters="left"
                    hide-delimiter-background
                    height="100vh">

                    <v-carousel-item
                        v-for="(panel, index) in panels"
                        :key="index"
                        :cover="true">
                        
                        <Component 
                            :is="panel" 
                            :panel="index"
                            :current-panel="currentPanel"
                            :current-category="category"
                            class="h-full pb-32" 
                            @on-category-selected="onCategorySelected"
                        />

                    </v-carousel-item>
                    
                </v-carousel>

            </div>

        </div>

        <NavigationArrow
            v-model="currentPanel" 
            :count="panels.length"
        />

    </div>

</template>